import {
  ClickableLegendItem,
  ConnectedInformationButton,
  ValueLegend,
} from "src/main";
import s from "../NetWorthPage.module.scss";
import { IGlobalPeriodContext, useGlobalPeriod } from "@iliotech/data-wire";
import { Typography } from "@progress/kendo-react-common";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import BreakDownChart from "src/components/__consumerCharts/BreakdownChart/BreakDownChart";
import React from "react";
import { BreakdownSeriesChartItem } from "@iliotech/data-wire/src/processing/breakdown";
import { Toggle } from "../../../Toggle/Toggle";
interface IProps {
  timeSeriesData: BreakdownSeriesChartItem[];
  currencyFormatter?: (v?: number) => string;
  daysRange?: number;
  breakdownTotals: (ClickableLegendItem & { exposureBase: number })[];
  height?: number;
  width?: number;
  isHalfHeight?: boolean;
  isPdf?: boolean;
  periodOverride?: IGlobalPeriodContext;
}

export const BreakdownHistoryChart = ({
  timeSeriesData,
  currencyFormatter,
  daysRange,
  breakdownTotals,
  height,
  width,
  isHalfHeight,
  isPdf,
  periodOverride,
}: IProps) => {
  const { periodString } = periodOverride || useGlobalPeriod();
  const { t } = useTranslation();
  const { h6: H6, p: P } = Typography;
  const [byExposure, setByExposure] = React.useState(false);
  const { timeData, breakdownData } = React.useMemo(() => {
    const timeData = timeSeriesData.map((item) => ({
      ...item,
      entries: item.entries.map((entry) => ({
        ...entry,
        value: byExposure ? entry.exposureValue : entry.value,
      })),
    }));

    const breakdownData = breakdownTotals.map((item) => ({
      ...item,
      value: byExposure ? item.exposureBase : item.value,
    }));

    return { timeData, breakdownData };
  }, [byExposure, timeSeriesData, breakdownTotals]);

  const Wrapper = isPdf ? "div" : "article";
  return (
    <Wrapper
      className={classNames(s.portfolioBreakdownSurround, isPdf && s.pdf)}
    >
      <div className={classNames(s.row, !isHalfHeight && s.col)}>
        <ConnectedInformationButton
          code={"netWorthBreakdown"}
          extraClass={"with-margin-bottom"}
        >
          <h6 className={"element-title"}>
            {t(
              byExposure
                ? "Portfolio breakdown history by exposure"
                : "Portfolio breakdown history by value"
            )}
          </h6>
        </ConnectedInformationButton>
        <Toggle
          left={t("by value")}
          right={t("by exposure")}
          onClick={(val) => {
            setByExposure(!byExposure);
          }}
        />
      </div>
      <P className={"period-string"}>{periodString}</P>
      <BreakDownChart
        height={height}
        width={width}
        daysRange={daysRange}
        timeSeriesData={timeData}
        currencyFormatter={currencyFormatter}
      />
      <ValueLegend small={isHalfHeight} items={breakdownData} />
    </Wrapper>
  );
};
